import { Card, CardContent } from "@/components/ui/card";

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 sm:p-10 bg-slate-50">
      <Card className="w-full max-w-md athena-shadow border-slate-200">
        <CardContent className="p-8">
          <div className="mb-6 flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center p-1">
              <img src="/logo-athena.png" alt="Centro Studi Athena" className="w-full h-full object-contain" />
            </div>
            <div className="font-display font-bold text-lg">Athena Portal</div>
          </div>
          <h2 className="font-display text-2xl font-bold text-slate-900">{title}</h2>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
          <div className="mt-6">{children}</div>
        </CardContent>
      </Card>
    </div>
  );
}
